module.exports = __webpack_public_path__ + "static/media/Decoraciones-para-eventos.8209a570.JPG";